import { useTranslation } from "react-i18next";

import { FilterOutlined } from "@ant-design/icons";
import { Row, Select, Space } from "antd";
import { Button } from "components/elements";
import MyTeamAttendanceTable from "components/table/MyTeamAttendanceTable";

function MyTeamAttendance({
  pagination = {},
  isLoading = false,
  selectedYear = null,
  attendanceList = [],
  onFilter = () => {},
  onYearChange = () => {},
}) {
  const { t } = useTranslation();

  return (
    <Space style={{ width: "100%" }} size={24} direction="vertical">
      <Row justify="space-between">
        <Select
          value={selectedYear}
          defaultValue={selectedYear}
          onChange={onYearChange}
          style={{ width: 120 }}
          options={[]}
        />
        <Button type="default" onClick={onFilter}>
          {t("common.filter")} <FilterOutlined />
        </Button>
      </Row>
      <MyTeamAttendanceTable
        isLoading={isLoading}
        dataSource={attendanceList}
        pagination={pagination}
      />
    </Space>
  );
}

export default MyTeamAttendance;
